/**
 * Animation Configurations for GeneratingPlaceholder
 *
 * Enthält Nebula-Blob-Konfigurationen und CSS-Keyframes
 */

export interface NebulaBlob {
  width: string;
  height: string;
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
  blur: string;
  gradientDark: string;
  gradientLight: string;
  animation: string;
}

export const nebulaBlobs: NebulaBlob[] = [
  {
    width: '120%',
    height: '120%',
    left: '-10%',
    top: '-10%',
    blur: 'blur-3xl',
    gradientDark: 'radial-gradient(circle, rgba(194, 65, 12, 0.25) 0%, transparent 70%)',
    gradientLight: 'radial-gradient(circle, rgba(251, 146, 60, 0.35) 0%, transparent 70%)',
    animation: 'nebula-drift-1 12s ease-in-out infinite',
  },
  {
    width: '80%',
    height: '80%',
    right: '-20%',
    bottom: '-20%',
    blur: 'blur-2xl',
    gradientDark: 'radial-gradient(circle, rgba(180, 83, 9, 0.3) 0%, transparent 65%)',
    gradientLight: 'radial-gradient(circle, rgba(251, 191, 36, 0.4) 0%, transparent 65%)',
    animation: 'nebula-drift-2 15s ease-in-out infinite',
  },
  {
    width: '60%',
    height: '60%',
    left: '20%',
    top: '30%',
    blur: 'blur-xl',
    gradientDark: 'radial-gradient(circle, rgba(234, 88, 12, 0.2) 0%, transparent 60%)',
    gradientLight: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, transparent 60%)',
    animation: 'nebula-drift-3 10s ease-in-out infinite',
  },
  {
    width: '50%',
    height: '50%',
    left: '25%',
    top: '25%',
    blur: 'blur-2xl',
    gradientDark: 'radial-gradient(circle, rgba(251, 146, 60, 0.15) 0%, transparent 50%)',
    gradientLight: 'radial-gradient(circle, rgba(253, 186, 116, 0.4) 0%, transparent 50%)',
    animation: 'nebula-pulse 6s ease-in-out infinite',
  },
];

export const animationKeyframes = `
  @keyframes shimmer {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(100%); }
  }

  @keyframes nebula-drift-1 {
    0%, 100% {
      transform: translate(0, 0) scale(1) rotate(0deg);
      opacity: 0.8;
    }
    25% {
      transform: translate(5%, 8%) scale(1.05) rotate(2deg);
      opacity: 1;
    }
    50% {
      transform: translate(10%, 5%) scale(1.1) rotate(0deg);
      opacity: 0.9;
    }
    75% {
      transform: translate(3%, -3%) scale(1.02) rotate(-2deg);
      opacity: 1;
    }
  }

  @keyframes nebula-drift-2 {
    0%, 100% {
      transform: translate(0, 0) scale(1);
      opacity: 0.7;
    }
    33% {
      transform: translate(-8%, 5%) scale(1.08);
      opacity: 0.9;
    }
    66% {
      transform: translate(-5%, -8%) scale(0.95);
      opacity: 0.8;
    }
  }

  @keyframes nebula-drift-3 {
    0%, 100% {
      transform: translate(0, 0) scale(1);
      opacity: 0.6;
    }
    50% {
      transform: translate(-10%, 10%) scale(1.15);
      opacity: 0.85;
    }
  }

  @keyframes nebula-pulse {
    0%, 100% {
      transform: scale(1);
      opacity: 0.5;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }
  }
`;
